import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { Article } from '@api/types/Article';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { generateGuid, invalidFormValue, isValidUrl } from '@components/utils';
import { getCurrentLanguageCode } from '@translations/functions';



export const selectOriginalArticle = (state: RootState) => state.article.originalArticle;
export const selectGuid = (state: RootState) => state.article.guid;
export const selectCountry = (state: RootState) => state.article.country;
export const selectUrl = (state: RootState) => state.article.url;
export const selectName = (state: RootState) => state.article.name;
export const selectContent = (state: RootState) => state.article.content;



export const selectValidArticle = createSelector(
	[
		selectGuid,
		selectCountry,
		selectUrl,
		selectName,
		selectContent,
	],(
		guid: string | null,
		country: AppLanguageCode | null,
		url: string,
		name: string,
		content: string,
	) => {
		if (!isValidUrl(url)) return null;
		if (invalidFormValue(name)) return null;
		if (invalidFormValue(content)) return null;
		
		const newArticle: Article = {
			guid: guid ? guid : generateGuid(),
			country: country ? country : getCurrentLanguageCode(),
			url: url,
			name: name,
			content: content
		}
		return newArticle;
	}
);